<template>
  <!-- 開發中 -->
  <transition name="fade">
    <FixedPopup v-show="noticePopup">
      <div class="selectAstrolabeBox">
        <div class="selectAstrolabeBox__title">选择想启用的星盘</div>
        <div class="selectAstrolabeBox__filter">
          <label>
            <img class="serachIcon" src="@/assets/占星小鋪/search.svg" alt="" />
            <input
              type="text"
              placeholder="搜尋星盤名稱"
              v-model="searchKey_temp"
              @keyup.enter="filterHandler"
            />
          </label>
          <button class="filter_btn" @click="filterHandler">搜寻</button>
        </div>
        <div class="selectAstrolabeBox__list" v-if="list_filter.length > 0">
          <div
            class="selectAstrolabeItem"
            v-for="item in list_filter"
            :key="item.AstrolabeFileId"
          >
            <div class="selectAstrolabeItem__pic">
              <img :src="item.ProfilePhotoSrc" alt="" />
            </div>
            <div class="selectAstrolabeItem__info">
              <div class="selectAstrolabeItem__info__name">{{ item.Name }}</div>
              <div class="selectAstrolabeItem__info__birthday">
                {{ item.BirthDate }}
              </div>
            </div>
            <div class="selectAstrolabeItem__btn" @click="selectHandler(item)">
              <img src="@/assets/占星小鋪/select.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="selectAstrolabeBox__empty" v-else>
          <div>
            {{
              list_all.length > 0
                ? "無符合條件的星盤"
                : "全部星盤已解鎖，沒有能夠選擇的對象"
            }}
          </div>
        </div>
        <div class="selectAstrolabeBox__closeBtn">
          <img src="@/assets/月亮日記/close.svg" alt="" @click="cancel()" />
        </div>
      </div>
    </FixedPopup>
  </transition>
</template>

<script>
import FixedPopup from "@/components/Fixed_popup.vue";
import Vue from "vue";

// let imgList = [
//   require("@/assets/月亮日記/這天寫過了.svg"),
//   require("@/assets/develop.svg"),
// ];

export default {
  components: { FixedPopup },
  data() {
    return {
      noticePopup: false,
      searchKey_temp: "",
      searchKey: "",
      callback: null,
    };
  },
  created() {
    Vue.prototype.$selectAstrolabe = (arg) => {
      this.noticePopup = true;
      this.callback = arg.callback;
    };
  },
  computed: {
    list_all() {
      if(!this.$store.state.userData || !this.$store.state.userData.AstrolabeFriendLists) return [];
      return this.$store.state.userData.AstrolabeFriendLists.filter((item) => {
        return !item.IsUnlockBC;
      });
    },
    list_filter() {
      return this.list_all.filter((item) => {
        return item.Name.includes(this.searchKey);
      });
    },
  },
  methods: {
    filterHandler() {
      this.searchKey = this.searchKey_temp;
    },
    cancel() {
      this.noticePopup = false;
      this.searchKey = "";
    },
    selectHandler(item) {
      this.noticePopup = false;
      this.searchKey = "";
      this.callback(item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_mixin.scss";

.selectAstrolabeBox {
  z-index: 1050;
  margin: auto;
  @include rect(520px, auto, $theme-color-3, 50px);
  @include center;
  flex-direction: column;
  padding: 36px;
  transition: 0.5s;
  position: relative;
  @include mobile() {
    @include rect(326px, auto, $theme-color-3, 110px);
    margin: 0 24px;
    padding: 32px 28px;
  }
  &__title {
    color: $secondary-color-1;
    font-weight: 700;
    font-size: 24px;
    text-align: center;
  }
  &__filter {
    margin-top: 36px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    @include mobile {
      margin-top: 24px;
    }
    label {
      flex-grow: 1;
      position: relative;
      .serachIcon {
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
      input,
      input:focus {
        width: 100%;
        height: 36px;
        background: #f0f2f4;
        box-shadow: 2px 2px 4px rgba(238, 109, 175, 0.22), inset 2px 2px 4px rgba(0, 0, 0, 0.15);
        border-radius: 25px;
        outline: none;
        padding: 8px 46px;
        @include mobile {
          max-width: 179px;
          height: 36px;
        }
      }
      input::placeholder {
        font-size: 14px;
        line-height: 20px;
        color: #d9d9d9;
      }
    }
    .filter_btn {
      @include btn-default(112px, 36px);
      border-radius: 100px;
      @include mobile {
        @include btn-default(72px, 36px);
      }
    }
  }
  &__list {
    margin-top: 34px;
    margin-right: -20px;
    padding-right: 20px;
    width: calc(100% + 20px);
    max-height: 458px;
    overflow-y: auto;
    overflow-y: overlay;
    @include scroll-primary;
  }
  &__empty {
    margin-top: 34px;
    font-size: 18px;
    line-height: 26px;
    color: #9b9b9b;
    text-align: center;
  }
  &__closeBtn {
    position: absolute;
    top: 12px;
    right: 16px;
    cursor: pointer;
    @include mobile {
      top: 16px;
      right: 12px;
    }
    img {
      width: 40px;
      height: 40px;
      @include mobile {
        width: 36px;
        height: 36px;
      }
    }
  }
}

.selectAstrolabeItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;
  &:last-child {
    margin-bottom: 0;
  }
  &__pic {
    width: 80px;
    height: 80px;
    padding: 8px;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: -1px -1px 4px rgba(238, 109, 175, 0.22),
      2px 2px 6px rgba(0, 0, 0, 0.25);
    img {
      width: 100%;
    }
  }
  &__info {
    flex-grow: 1;
    margin-left: 20px;
    &__name {
      font-size: 18px;
      line-height: 36px;
      font-weight: 700;
      color: #767676;
    }
    &__birthday {
      font-size: 14px;
      line-height: 28px;
      color: #9b9b9b;
    }
  }
  &__btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f0f2f4;
    box-shadow: -1px -1px 4px rgba(238, 109, 175, 0.22),
      2px 2px 6px rgba(0, 0, 0, 0.25);
    display: flex;
    cursor: pointer;
    img {
      margin: auto;
      width: 20px;
    }
  }
}
</style>
